import { Input, Stack, Text } from "@chakra-ui/react";
import React from "react";

export default function LabelInput({ label, placeholder, props }) {
  return (
    <Stack {...props}>
      <Text>{label}</Text>
      <Input
        placeholder={placeholder}
        borderWidth={0}
        borderBottomWidth={1}
        borderColor="#001E1E80"
      />
    </Stack>
  );
}
